module.exports = __webpack_public_path__ + "static/media/sykling.92348043.svg";